/* eslint import/prefer-default-export:off */
export const bodyClass = 'cdm-wp-page-single';
export const bodyHomeClass = 'lmb-homepage';
export const bodyClassPrefix = 'cdm-wp-page-';
export const wpFootnoteClass = 'cdm-footnote-container';

export const titleRelated = 'Featured Articles';
export const btnLabel = 'LOAD MORE';
